module.exports = __webpack_public_path__ + "img/kitkitimg2@4x.497c5fac.png";